import { flow } from 'mobx-state-tree';

import { getStores } from '../..';

export const getFavouritesRequestOptions = (self, config) => ({
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  crossDomain: true,
  credentials: 'include',
  body: JSON.stringify({
    id: config.gysService.ownerId,
    pois: self.list.map((poi) => poi.id),
  }),
});

export const addFavourite = flow(function* (self, poi) {
  const { config } = getStores(self, 'config');
  if (config.gysService.useMock) return;
  if (self.list.filter((x) => x.id === poi.id)?.length > 0) return;
  try {
    self.list.push(JSON.parse(JSON.stringify(poi)));
    yield fetch(
      `${config.gysService.url}/get-your-spot/favorites`,
      getFavouritesRequestOptions(self, config),
    );
  } catch (error) {
    console.error(error);
  }
});
